module.exports = __webpack_public_path__ + "img/coop_luque.a8e82447.png";